import usePasswordToggle from "../../utils/usePasswordToggle";

const PasswordInput = ({ id, label_content, value, onChange, placeholder }) => {
  const [InputType, Icon] = usePasswordToggle();

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="block text-sm font-medium text-gray-900">
        {label_content}
      </label>
      <div className="relative">
        <input
          id={id}
          type={InputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required
          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 
                     outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
                     focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm"
        />
        {Icon}
      </div>
    </div>
  );
};

export default PasswordInput;
